import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/sos-logo.png'


const _hoisted_1 = { class: "flex justify-between bg-success relative z-10" }
const _hoisted_2 = { class: "flex h-full xl:justify-between w-full" }
const _hoisted_3 = { class: "flex h-full w-[8rem] xl:w-[7%] mx-[3%] py-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo beepi",
  class: "object-contain"
}, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "hidden md:flex items-center w-4/6 xl:w-1/3"
}
const _hoisted_6 = { class: "hidden md:flex w-full items-center justify-between gap-4 h-full" }
const _hoisted_7 = {
  key: 1,
  class: "hidden md:flex items-center justify-center w-2/6"
}
const _hoisted_8 = { class: "flex items-center relative mr-10" }
const _hoisted_9 = { class: "flex flex-col w-full relative" }
const _hoisted_10 = { class: "py-2 px-4 bg-gray-800 text-white rounded-t-lg flex items-center justify-between" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold ml-2" }, "Notificaciones", -1)
const _hoisted_12 = {
  key: 0,
  class: "p-1"
}
const _hoisted_13 = { class: "mr-2" }
const _hoisted_14 = ["onChange"]
const _hoisted_15 = { class: "text-sm text-gray-800" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "bg-green-100 p-3 mb-1 rounded-lg flex items-center mr-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-800" }, "No se registran notificaciones")
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 left-2 transform -translate-y-2 bg-gray-800 w-6 h-6 rotate-45" }, null, -1)
const _hoisted_20 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("figure", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/my-communities",
          class: ""
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      (_ctx.authSuperUser)
        ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("nav", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/my-communities",
                class: "overflow-hidden text-sm h-full font-normal xl:font-semibold text-white hover:text-gray-800 focus:outline-none focus:text-white transition duration-150 ease-in-out"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'bg-white mt-1.5 ': _ctx.$route.path.includes('communi') }, "flex items-center h-full p-2 rounded-t-lg"])
                  }, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["backdrop-filter whitespace-nowrap", { 'backdrop-blur-md text-success pb-3 font-semibold': _ctx.$route.path.includes('communi') }])
                    }, " Comunidades ", 2)
                  ], 2)
                ]),
                _: 1
              }),
              (_ctx.authSuperUser?.isSuperuser)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/my-instructions",
                    class: "overflow-hidden text-sm h-full font-normal xl:font-semibold text-white hover:text-gray-800 focus:outline-none focus:text-white transition duration-150 ease-in-out"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass([{ 'bg-white mt-1.5': _ctx.$route.path.includes('instructions') }, "flex items-center h-full p-2 rounded-t-lg"])
                      }, [
                        _createElementVNode("p", {
                          class: _normalizeClass(["backdrop-filter", { 'backdrop-blur-md text-success pb-3 font-semibold': _ctx.$route.path.includes('instructions') }])
                        }, " Configuración de instrucciones ", 2)
                      ], 2)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, {
                to: "/my-queries",
                class: "overflow-hidden text-sm h-full font-normal xl:font-semibold text-white hover:text-gray-800 focus:outline-none focus:text-white transition duration-150 ease-in-out"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'bg-white mt-1.5 ': _ctx.$route.path.includes('queries') }, "flex items-center h-full p-2 rounded-t-lg"])
                  }, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["backdrop-filter", { 'backdrop-blur-md text-success pb-3 font-semibold': _ctx.$route.path.includes('queries') }])
                    }, " Consultas ", 2)
                  ], 2)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.authSuperUser)
        ? (_openBlock(), _createElementBlock("aside", _hoisted_7, [
            _createElementVNode("figure", _hoisted_8, [
              _createVNode(_component_mdicon, {
                class: "cursor-pointer ml-2 text-white hover:text-gray-800",
                name: "bell",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hiddenNotification()))
              }),
              (_ctx.notifications.length > 0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hiddenNotification())),
                    class: "cursor-pointer absolute top-0 right-0 bg-red-500 text-white rounded-full w-3.5 h-3.5 flex items-center justify-center text-xs"
                  }, _toDisplayString(_ctx.notifications.length), 1))
                : _createCommentVNode("", true),
              (_ctx.showNotifications)
                ? (_openBlock(), _createElementBlock("header", {
                    key: 1,
                    class: _normalizeClass(["hidden md:flex absolute bg-white rounded-lg shadow-lg w-64 left-0 mt-11 z-10", { 'top-0': _ctx.showNotifications }])
                  }, [
                    _createElementVNode("article", _hoisted_9, [
                      _createElementVNode("section", _hoisted_10, [
                        _hoisted_11,
                        (_ctx.checkNotification.length > 0)
                          ? (_openBlock(), _createBlock(_component_mdicon, {
                              key: 0,
                              size: "30",
                              class: "cursor-pointer pr-4 font-semibold text-white hover:text-success focus:outline-none focus:text-white transition duration-150 ease-in-out text-white hover:text-gray-800",
                              name: "send-circle",
                              onClick: _ctx.sendCheckNotification
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.notifications.length > 0)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: notification.id,
                                class: "bg-green-100 p-3 mb-1 rounded-lg flex items-center"
                              }, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    onChange: ($event: any) => (_ctx.saveNotification(notification.id)),
                                    class: "form-checkbox h-4 w-4 text-green-500"
                                  }, null, 40, _hoisted_14)
                                ]),
                                _createElementVNode("p", _hoisted_15, _toDisplayString(notification.description), 1)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("section", _hoisted_16, _hoisted_18)),
                      _hoisted_19
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addOpenAlert && _ctx.addOpenAlert(...args))),
                class: "pr-4 text-sm font-semibold text-white hover:text-gray-800 focus:outline-none focus:text-white transition duration-150 ease-in-out"
              }, " Cerrar Sesión ")
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_ModalAlert, {
        title: 'Cerrar Sesion',
        message: '¿Está seguro que desea cerrar sesión?',
        visible: _ctx.showModalAlert,
        option: false,
        onAccept: _ctx.handleAccept,
        onCancelAlert: _ctx.handleCancel
      }, null, 8, ["visible", "onAccept", "onCancelAlert"])
    ])
  ]))
}